import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import * as styles from './Previews.scss';

var PrivacyPolicyPreview = /*#__PURE__*/function (_Component) {
  _inherits(PrivacyPolicyPreview, _Component);

  var _super = _createSuper(PrivacyPolicyPreview);

  function PrivacyPolicyPreview() {
    _classCallCheck(this, PrivacyPolicyPreview);

    return _super.apply(this, arguments);
  }

  _createClass(PrivacyPolicyPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formValues = _this$props.formValues,
          pageInfo = _this$props.pageInfo;
      var customConsents = null;

      if (formValues.customDisclaimerConsents.length) {
        console.log(formValues.customDisclaimerConsents);
        customConsents = formValues.customDisclaimerConsents.map(function (consentItem, index) {
          var consentLabel = /*#__PURE__*/React.createElement("span", {
            className: styles.consentRadioLabel
          }, consentItem.text, !consentItem.isRequired && /*#__PURE__*/React.createElement("span", {
            className: styles.consentOptionalText
          }, " (optional)"));
          return /*#__PURE__*/React.createElement(RadioButtonGroup, null, /*#__PURE__*/React.createElement(RadioButton, {
            labelStyle: {
              fontSize: 12
            },
            style: {
              marginTop: 8
            },
            value: index,
            key: index,
            label: consentLabel
          }));
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.previewWrap
      }, formValues.customDisclaimerEnabled && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.headline
      }, formValues.customDisclaimerTitle ? formValues.customDisclaimerTitle : "Terms and Conditions for ".concat(pageInfo.username)), formValues.customDisclaimerText && /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.privacyText, " ").concat(styles.customPrivacyText)
      }, formValues.customDisclaimerText), customConsents && /*#__PURE__*/React.createElement("div", {
        className: styles.consentsWrap
      }, customConsents), /*#__PURE__*/React.createElement("div", {
        className: styles.hr
      })), /*#__PURE__*/React.createElement("span", {
        className: styles.privacyText
      }, "By clicking Submit, you agree to send your info to ", pageInfo.username, " who agrees to use it according to their privacy policy and the above Terms. Facebook will also use it subject to our Data Policy, including to auto-fill forms for ads.", ' ', /*#__PURE__*/React.createElement(Link, {
        className: styles.link,
        to: "https://www.facebook.com/policy.php",
        target: "_blank"
      }, "View Facebook Data Policy."), ' ', /*#__PURE__*/React.createElement(Link, {
        className: styles.link,
        to: formValues.privacyPolicyURL,
        target: "_blank"
      }, formValues.privacyPolicyLinkText ? formValues.privacyPolicyLinkText : "View ".concat(pageInfo.username, "'s Privacy Policy"), ".")));
    }
  }]);

  return PrivacyPolicyPreview;
}(Component);

export { PrivacyPolicyPreview as default };